export default __webpack_public_path__ + "static/media/blog_inner_23.372fb24f.jpg";